import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import ClearIcon from '@mui/icons-material/Clear'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Button, Checkbox, Chip, CircularProgress, Container, CssBaseline, FormControlLabel, Grid, Radio, RadioGroup, TextField } from "@mui/material"
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import Pagination from '@mui/material/Pagination'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { withStyles } from "@mui/styles"
import clsx from 'clsx'
import 'jspdf-autotable'
import moment from "moment"
import PropTypes from "prop-types"
import React, { Component } from "react"
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SimpleAutoComplete from "src/components/auto-complete/autocomplete-dialog-with-z-index"
import Api2Talk from "src/services/api2talk"
import { PapiroConsole } from "src/utils/papiroConsole"
import styled from 'styled-components'
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import Footer from '../../components/footer'
import HeaderMenu from "../../components/header-menu"
import CustomizedSnackbars from "../../components/material-snackbars"
import MyMaterialTable from '../../components/table'
import { AbilityContext, Can } from '../../config/ability-context'
import * as calledsActions from '../../redux/actions/calleds'
import * as ItemService from '../../services/2talk/channel'
import Api from "../../services/api"
import ApiReports from "../../services/apireport"
import * as FileService from '../../services/attachment.service'
import { Overlay } from "../../styles/global"
import { Styles } from "../../styles/material-styles"

import AttachmentIcon from '@mui/icons-material/Attachment'
import { MESSAGE_PROVIDER_WHATSAPP } from 'src/utils/contantes/message-provider'
import { PROVIDER_CONFIG, PROVIDER_CONFIG_NAME } from 'src/utils/enums/provider-config'
import AutoCompleteMultipleSelectSimple from "src/components/auto-complete/autocomplete-multiple-select-simple";


const StyledTypography = styled(Typography)({
  cursor: 'pointer',
  '&:hover': {
    color: '#3f51b5',
    textDecoration: 'underline',
  },
});

const formatDuration = (start, end, seconds = null) => {
  const diff = seconds !== null
    ? seconds
    : (!start || !end ? null : moment(end).diff(moment(start), 'seconds'))
  if (diff === null || diff < 0) return '-'
  const h = Math.floor(diff / 3600)
  const m = Math.floor((diff % 3600) / 60)
  const s = diff % 60
  if (h > 0) return `${h}h ${m}m`
  if (m > 0) return `${m}m ${s}s`
  return `${s}s`
}

const getStatusChipColor = (statusName) => {
  if (!statusName) return 'default'
  const name = statusName.toLowerCase()
  if (name.includes('resolv') || name.includes('encerr') || name.includes('finaliz')) return 'success'
  if (name.includes('abandon') || name.includes('cancel') || name.includes('erro')) return 'error'
  if (name.includes('fila') || name.includes('espera')) return 'warning'
  if (name.includes('transfer') || name.includes('humano') || name.includes('atendimento')) return 'primary'
  return 'default'
}

const WAIT_TIME_ALERT_SECONDS = 5 * 60
const HUMAN_DURATION_ALERT_SECONDS = 30 * 60
const TRANSFER_COUNT_ALERT = 2

class ChatReport extends Component {

  constructor(props) {
    super(props)

    this.isClient = true
    this.isAdm = false
    this.typingTimeout = null
    this.organizationId = null

    const { userSession } = this.props

    if (userSession == null || userSession.user == null || userSession.user.userrole == null)
      Api.logoff()

    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype != 3)
        this.isClient = false
      if (item.role.roletype == 0 || item.role.roletype == 1)
        this.isAdm = true
    });

    if (userSession.user.organization)
      this.organizationId = userSession.user.organization.id

    this.formDataInitialState = {
      MessageProviderId: null,
      channelId: null,
      statusId: null,
    }

    this.state = {
      formData: this.formDataInitialState,
      id: '',
      requestuser: '',
      assigned: '',
      channelOptions: [],
      optionsMessageProviders: [],
      statusOptions: [],
      dateStart: moment().format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      organizationId: this.organizationId,
      OrganizationFilter: 0,
      location: 0,
      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      showGrid: false,
      calledsList: [],
      organizationList: [],
      organizationAddressesList: [],
      calledPdfList: [],
      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      searchValue: '',
      showHeader: false,
      strhtmlModalOpen: false,
      dialogHTMLString: [],
      radioSelectedOption: "1",
      chatId: null,
      hasTicket: false,
      currentChat: null,
      onlyIa: false,
      onlyHuman: false,
      metrics: null,
      listTagsToFilter: [],
      selectedTags: [],
      selectedTagIds: [],
    }
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleAutocompleteChange = (name, value) => {
    this.setState({ [name]: value });
  };

  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  };

  handleChangeAutoComplete = async (stateName, value) => {
    let data = value.id > 0 ? value : null;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [stateName]: data
      }
    }));
  }

  openHTMLRenderModal = (item) => {
    this.setState({ loading: true })
    Api2Talk.get(`/chat/messages/bychat/${item.id}`)
      .then(result => {
        if (result.data.success) {
          this.setState({
            strhtmlModalOpen: true,
            dialogHTMLString: result.data.data,
            loading: false,
            chatId: item.id,
            currentChat: item,
          })
        } else {
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(result)
        }
      })
      .catch(err => {
        PapiroConsole.log("=== Catch(e) ===")
        PapiroConsole.log(err)
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        })
        Api.kickoff(err)
      })
  }


  closeHTMLRenderModal = () => {
    this.setState({ strhtmlModalOpen: false, dialogHTMLString: [], chatId: null, currentChat: null })
  }

  changeValues = async (stateName, value, text = '') => {
    this.setState({ [stateName]: value });
  };

  Reload = () => {
    const reload = localStorage.getItem('reload')
    if (reload == "true")
      localStorage.setItem('reload', false)
    return null;
  }

  onChangePaginate = (e, page) => {
    this.setState({ page: page })
    this.getCalleds('', page)
  }

  exportPdf = _ => {
    this.getCalledsToPdf()
  }

  setPagination = (count, page) => {
    let totalPage = Math.ceil(count / 10)
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        if (count < 10)
          this.setState({ pageStart: 1, pageEnd: count })
        else
          this.setState({ pageStart: 1, pageEnd: 10 })
      } else {
        let pageStart = ((page - 1) * 10) + 1
        if (count >= page * 10)
          this.setState({ pageStart: pageStart, pageEnd: page * 10 })
        else
          this.setState({ pageStart: pageStart, pageEnd: count })
      }
    } else
      this.setState({ totalPages: 0, page: 1, count: 0 })
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await this.getOrganizations();
    await this.getChannelList()
    await this.fetchOptionsMessageProvider();
    await this.getTags();
    await this.fetchStatusOptions();
    await this.getMetrics();
    this.setState({ loading: false });
  }

  getOrganizations = async () => {
    try {
      const result = await Api.get('/organizations/tech');
      this.setState({ organizationList: result.data?.data || [] });
    } catch (err) {
      this.fetchDataThrowError(err);
      Api.kickoff(err);
    }
  }

  fetchDataNotSuccess(result) {
    const intl = this.props.intl;
    this.setState({
      loading: false, openNotification: true, notificationVariant: "error",
      notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
    });
  }

  fetchDataThrowError(err) {
    const intl = this.props.intl;
    this.setState({
      loading: false, openNotification: true, notificationVariant: "error",
      notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
    });
  }

  fetchOptionsMessageProvider = async () => {
    Api2Talk.get(`/messageprovider`)
      .then(result => {
        if (result.data.success) {
          const messageProviderOptions = result.data.data;
          this.setState(prevState => ({
            optionsMessageProviders: messageProviderOptions
          }))
        } else {
          this.fetchDataNotSuccess(result);
          Api.kickoff(result);
        }
      })
      .catch(err => {
        this.setState({ loading: false });
        this.fetchDataThrowError(err);
        Api.kickoff(err);
      });
  }

  async getChannelList() {
    const response = await ItemService.getChannelList();
    if (response.success) {
      const channels = response.data?.map(channel => ({ id: channel.id, name: channel.name, isdefault: false }));
      this.setState({ channelOptions: channels });
    } else {
      const intl = this.props.intl;
      this.setState({
        loading: false, openNotification: true, notificationVariant: "error",
        notificationMessage: response.data && response.data.response && response.data.response.data && response.data.response.data.errors && response.data.response.data.errors[0] ? response.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      })
    }
  }

  fetchStatusOptions = async () => {
    Api2Talk.get(`/chatstatus`)
      .then(result => {
        if (result.data.success) {
          this.setState({ statusOptions: result.data.data })
        } else {
          this.fetchDataNotSuccess(result);
          Api.kickoff(result);
        }
      })
      .catch(err => {
        this.fetchDataThrowError(err);
        Api.kickoff(err);
      });
  }

  getCalleds = async (filter = '', page = 1) => {
    const intl = this.props.intl;
    this.setState({ loading: true });

    let url = `/report/2talk-chat-report/paginate?page=${page}`

    url += `&dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}`

    if (this.state.formData.MessageProviderId && this.state.formData.MessageProviderId.id && this.state.formData.MessageProviderId.id > 0) {
      url += `&messageProviderId=${this.state.formData.MessageProviderId.id}`
    }
    if (this.state.formData.channelId && this.state.formData.channelId.id && this.state.formData.channelId.id > 0) {
      url += `&channelId=${this.state.formData.channelId.id}`
    }
    if (this.state.id && this.state.id > 0)
      url += `&id=${this.state.id}`
    if (this.state.requestuser && this.state.requestuser.length > 0)
      url += `&requestUser=${this.state.requestuser}`
    if (this.state.assigned && this.state.assigned.length > 0)
      url += `&assignedUser=${this.state.assigned}`
    if (this.state.selectedTags && this.state.selectedTags.length > 0) {
      const selectedTagsIds = this.state.selectedTags.map(tag => tag.id).join(',');
      url += `&tagsIds=${selectedTagsIds}`;
    }
    if (this.state.formData.statusId && this.state.formData.statusId.id && this.state.formData.statusId.id > 0)
      url += `&statusId=${this.state.formData.statusId.id}`
    if (this.state.OrganizationFilter > 0)
      url += `&organizationId=${this.state.OrganizationFilter}`
    if (this.state.hasTicket)
      url += `&hasTicket=true`
    if (this.state.onlyIa)
      url += `&onlyIa=true`
    if (this.state.onlyHuman)
      url += `&onlyHuman=true`

    this.setState({ showGrid: true })

    ApiReports.get(url)
      .then(result => {
        if (result.data.success) {

          PapiroConsole.log(result)
          PapiroConsole.log("result aqui")
          console.log(result)
          console.log("result aqui")
          let count = result.data.count
          this.setState({ count: count })
          this.setPagination(count, page)

          let formattedList
          if (result.data.data.length > 0) {
            formattedList = result.data.data.map(item => {
              const formatted = {
                ...item,
                createdat: moment(item.createdat).format('DD/MM/YYYY HH:mm'),
                phone: item.messageproviderid == PROVIDER_CONFIG_NAME.WHATSAPP || item.messageproviderid == PROVIDER_CONFIG_NAME.WEBCHAT ? item.phone : '',
                iastartat: item.iastartat ? moment(item.iastartat).format('DD/MM/YYYY HH:mm') : '-',
                iaendat: item.iaendat ? moment(item.iaendat).format('DD/MM/YYYY HH:mm') : '-',
                iaduration: formatDuration(item.iastartat, item.iaendat),
                queueentryat: item.queueentryat ? moment(item.queueentryat).format('DD/MM/YYYY HH:mm') : '-',
                humanstartat: item.humanstartat ? moment(item.humanstartat).format('DD/MM/YYYY HH:mm') : '-',
                humanendat: item.humanendat ? moment(item.humanendat).format('DD/MM/YYYY HH:mm') : '-',
                humanduration: formatDuration(item.humanstartat, item.humanendat),
                waittime: formatDuration(item.queueentryat, item.humanstartat),
                waittimeseconds: (item.queueentryat && item.humanstartat)
                  ? moment(item.humanstartat).diff(moment(item.queueentryat), 'seconds') : 0,
                humandurationseconds: (item.humanstartat && item.humanendat)
                  ? moment(item.humanendat).diff(moment(item.humanstartat), 'seconds') : 0,
                conversationendat: item.conversationendat ? item.conversationendat : null,
                organizationname: item.organizationname,
                tags: item.tags,
              }
              formatted.Message = (
                <Tooltip title={intl.formatMessage({ id: "send.mail.report.view.email.body" })}>
                  <IconButton aria-label="textevidence" onClick={e => this.openHTMLRenderModal(formatted)}>
                    <ChatBubbleOutlineIcon />
                  </IconButton>
                </Tooltip>
              )
              return formatted
            })
          }
          PapiroConsole.log("=== formattedList ===")
          PapiroConsole.log(formattedList)

          this.setState({ calledsList: formattedList, loading: false })
        } else {
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(result)
        }
      })
      .catch(err => {
        PapiroConsole.log("=== Catch(e) ===")
        PapiroConsole.log(err)
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        })
        Api.kickoff(err)
      })
  }

  getTags = async (isLoading = false) => {
      if (isLoading)
          this.setState({ loading: true });

      Api.get('/tags/getAllToCalledReportFilter')
          .then(result => {
              if (result.data.success) {
                  const list = result?.data?.data ?? [];

                  this.setState({ listTagsToFilter: list });
              }
              else {
                  this.setState({
                      loading: false, openNotification: true, notificationVariant: 'error',
                      notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                  });
                  Api.kickoff(result);
              }
          })
          .catch(err => {
              this.setState({
                  loading: false, openNotification: true, notificationVariant: 'error',
                  notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
              });
              Api.kickoff(err);
          });
  }

handleChangeAutoCompleteMultipleSelectSimple = (selectedTags) => {
    this.setState({
        selectedTags: selectedTags || [],
        selectedTagIds: (selectedTags || []).map(tag => tag.id)
    });
};



  getMetrics = async () => {
    let url = `/report/2talk-chat-report/metrics?dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}`

    if (this.state.formData.MessageProviderId?.id > 0) url += `&messageProviderId=${this.state.formData.MessageProviderId.id}`
    if (this.state.formData.channelId?.id > 0) url += `&channelId=${this.state.formData.channelId.id}`
    if (this.state.id > 0) url += `&id=${this.state.id}`
    if (this.state.requestuser) url += `&requestUser=${this.state.requestuser}`
    if (this.state.assigned) url += `&assignedUser=${this.state.assigned}`
    if (this.state.formData.statusId?.id > 0) url += `&statusId=${this.state.formData.statusId.id}`
    if (this.state.OrganizationFilter > 0) url += `&organizationId=${this.state.OrganizationFilter}`
    if (this.state.hasTicket) url += `&hasTicket=true`
    if (this.state.onlyIa) url += `&onlyIa=true`
    if (this.state.onlyHuman) url += `&onlyHuman=true`

    ApiReports.get(url)
      .then(result => {
        if (result.data.success)
          this.setState({ metrics: result.data.data.data })
      })
      .catch(err => console.log(err))
  }

  handleRadioChange = (event) => {
    if (event.target.value == "1") {
      this.setState({ radioSelectedOption: event.target.value, dateStart: moment().format('YYYY/MM/DD HH:mm:ss'), dateEnd: moment().format('YYYY/MM/DD HH:mm:ss') })
    }
    else if (event.target.value == "2") {
      this.setState({ radioSelectedOption: event.target.value, dateStart: moment().startOf('month').format('YYYY/MM/DD HH:mm:ss'), dateEnd: moment().format('YYYY/MM/DD HH:mm:ss') })
    }
    else if (event.target.value == "3") {
      this.setState({ radioSelectedOption: event.target.value, dateStart: moment().format('YYYY/MM/DD HH:mm:ss'), dateEnd: moment().format('YYYY/MM/DD HH:mm:ss') })
    }
  }

  getExcel = async () => {
    this.setState({ loading: true });
    let url = '/report/2talk-chat-report/excell';

    url += `?dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}`;

    const selectedTagsIds = (this.state.selectedTags || []).map(tag => tag.id).join(',');
    if (selectedTagsIds) {
      url += `&tagsIds=${selectedTagsIds}`;
    }

    if (this.state.formData.MessageProviderId?.id > 0) url += `&messageProviderId=${this.state.formData.MessageProviderId.id}`;
    if (this.state.formData.channelId?.id > 0) url += `&channelId=${this.state.formData.channelId.id}`;
    if (this.state.id > 0) url += `&id=${this.state.id}`;
    if (this.state.requestuser) url += `&requestUser=${this.state.requestuser}`;
    if (this.state.assigned) url += `&assignedUser=${this.state.assigned}`;
    if (this.state.formData.statusId?.id > 0) url += `&statusId=${this.state.formData.statusId.id}`;
    if (this.state.OrganizationFilter > 0) url += `&organizationId=${this.state.OrganizationFilter}`;
    if (this.state.hasTicket) url += `&hasTicket=true`;
    if (this.state.onlyIa) url += `&onlyIa=true`;
    if (this.state.onlyHuman) url += `&onlyHuman=true`;

    await ApiReports.get(url)
      .then((response) => {
        PapiroConsole.log(response)
        PapiroConsole.log("response")
        if (response.data.success) {
          PapiroConsole.log("success")
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")",
          });
        } else {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: response.data.errors && response.data.errors[0] ? response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: 'error',
          notificationMessage: error.data && error.data.response && error.data.response.data && error.data.response.data.errors && error.data.response.data.errors[0] ? error.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        });
      });

    this.setState({ loading: false });
  }

  getMessageExcellBadUseFlag = (message, status) => {
    const intl = this.props.intl;
    let writing = ""
    if (status === intl.formatMessage({ id: "finished" })) {
      if (message === true)
        writing = this.props.intl.formatMessage({ id: "yes" })
      else if (message === false)
        writing = this.props.intl.formatMessage({ id: "no" })
    } else
      writing = this.props.intl.formatMessage({ id: "undefined" })
    return writing
  }

  handleSubmit = async e => {
    const intl = this.props.intl;
    e.preventDefault();
    this.setState({ loading: true });
    var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')
    if (dateStart > dateEnd) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" }),
        loading: false
      });
    } else {
      await this.getCalleds(this.props.location.state)
      await this.getMetrics()
    }
  }

  closeNotification = _ => {
    this.setState({ openNotification: false });
  }

  renderMessageItem = (item) => {
    const { classes } = this.props
    const isBot = item.messageorigin === 5 || item.messageorigin === 4
    const isAgentOrSystem = item.messageorigin === 4 || item.messageorigin === 1

    const borderColor = item.messageorigin === 5
      ? '#7b1fa2'   // roxo = chatbot
      : item.messageorigin === 4
        ? '#00897b'   // teal = mensagem automática
        : item.messageorigin === 1
          ? '#1565c0'   // azul = agente humano
          : '#bdbdbd'   // cinza = cliente

    const cardStyle = { marginBottom: '12px', borderLeft: `4px solid ${borderColor}` }

    const content = (
      <CardContent>
        <Typography
          variant="body2"
          color="textSecondary"
          gutterBottom
          align={isAgentOrSystem ? 'right' : 'left'}
        >
          {item.sendername} — {moment(item.createdat).format('DD/MM/YYYY HH:mm')}
        </Typography>
        {item.attachment != null ? (
          <StyledTypography
            variant="body1"
            align={isAgentOrSystem ? 'right' : 'left'}
            onClick={() => this.getFile(item.attachment.hirerid, item.attachment.path, item.attachment.filerepositorymethod)}
          >
            <IconButton size="small"><AttachmentIcon /></IconButton>
            {item.message != null ? this.convertHtmlOption(item.message) : null}
          </StyledTypography>
        ) : (
          <Typography variant="body1" align={isAgentOrSystem ? 'right' : 'left'}>
            {item.message != null ? this.convertHtmlOption(item.message) : null}
          </Typography>
        )}
      </CardContent>
    )

    return (
      <Card key={item.id} className={isAgentOrSystem ? classes.root : classes.rootClient} style={cardStyle}>
        {content}
      </Card>
    )
  }

  renderDatePickerStart() {
    const { intl } = this.props
    return (
      <SimpleDatePicker label={intl.formatMessage({ id: "start.date" })} name='dateStart' stateName='dateStart' changeDate={this.changeValues} currentDate={this.state.dateStart} required />
    );
  }

  renderDatePickerEnd() {
    const { intl } = this.props
    return (
      <SimpleDatePicker label={intl.formatMessage({ id: "end.date" })} name='dateEnd' stateName='dateEnd' changeDate={this.changeValues} currentDate={this.state.dateEnd} required />
    );
  }

  convertHtmlOption = value => {
    PapiroConsole.log("=== convertHtmlOption ===")
    let body = value
    let temp = document.createElement("div")
    temp.innerHTML = body
    let found = null
    for (let i in temp.children) {
      if (temp.children[i].innerHTML && temp.children[i].innerHTML.toString().trim() != '<br>' && temp.children[i].innerHTML.toString().trim().length > 0) {
        found += temp.children[i].innerHTML.toString()
      }
    }
    let sanitized = temp.textContent.trim() || temp.innerText.trim() || found
    PapiroConsole.log(sanitized)
    return sanitized
  }

  getFile = async (hirerid, fileName, filerepositorymethod) => {
    const intl = this.props.intl;
    this.setState({ loading: true })
    await FileService.getFileByPath(hirerid, fileName, filerepositorymethod)
      .then(result => {
        if (result.data.success) {
          if (result && result.data && result.data.data && result.data.success) {
            window.open(`${result.data.data}`, '_blank');
          }
          this.setState({ loading: false })
        } else {
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(result)
        }
      })
      .catch(err => {
        PapiroConsole.log("=== Catch(e) ===")
        PapiroConsole.log(err)
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        })
        Api.kickoff(err)
      })
  };

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props
    const intl = this.props.intl

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    PapiroConsole.log(this.state.dialogHTMLString)

    const tableList = () => {
      return (
        <>
         <Dialog scroll="body" open={this.state.strhtmlModalOpen} onClose={this.closeHTMLRenderModal} aria-labelledby="form-dialog-title"  fullWidth   maxWidth="md"  PaperProps={{  style: {   maxHeight: '90vh',  overflowY: 'auto'   } }}
          >
            {/* Título */}
            <DialogTitle
              id="form-dialog-title"
              style={{ backgroundColor: '#3f50b5', color: 'white' }}
            >
              <span style={{ color: 'white' }}>
                {intl.formatMessage({ id: "messages.from.conversartion" })} — #{this.state.chatId}
              </span>
              <ClearIcon
                onClick={this.closeHTMLRenderModal}
                style={{ fill: 'white', float: 'right', cursor: 'pointer' }}
              />
            </DialogTitle>

            
            <DialogContent style={{ padding: '20px' }}>
             
              {this.state.currentChat && (
                <Card style={{ marginBottom: '16px', backgroundColor: '#f5f5f5' }}>
                  <CardContent style={{ paddingBottom: '12px' }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="body2" color="textSecondary">
                          {intl.formatMessage({ id: "channel" })}
                        </Typography>
                        <Typography variant="body1">
                          <strong>{this.state.currentChat.channelname || '-'}</strong>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="body2" color="textSecondary">
                          {intl.formatMessage({ id: "requestuser" })}
                        </Typography>
                        <Typography variant="body1">
                          <strong>{this.state.currentChat.requestinguser || this.state.currentChat.customername || '-'}</strong>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="body2" color="textSecondary">
                          {intl.formatMessage({ id: "requester.number" })}
                        </Typography>
                        <Typography variant="body1">
                          <strong>{this.state.currentChat.phone || '-'}</strong>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="body2" color="textSecondary">
                          {intl.formatMessage({ id: "status" })}
                        </Typography>
                        <Typography variant="body1">
                          {this.state.currentChat.statusname
                            ? <Chip label={this.state.currentChat.statusname} color={getStatusChipColor(this.state.currentChat.statusname)} size="small" />
                            : '-'}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="body2" color="textSecondary">
                          {intl.formatMessage({ id: "ticket" })}
                        </Typography>
                        <Typography variant="body1">
                          {this.state.currentChat.calledid
                            ? <Chip label={`#${this.state.currentChat.calledid}`} size="small" sx={{ backgroundColor: '#9c27b0', color: 'white' }} />
                            : '-'}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="body2" color="textSecondary">
                          {intl.formatMessage({ id: "assigned" })}
                        </Typography>
                        <Typography variant="body1">
                          <strong>{this.state.currentChat.assigneduser || '-'}</strong>
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              )}

              {this.state.currentChat && (() => {
                const chat = this.state.currentChat
                const events = []
                if (chat.createdat && chat.createdat !== '-')
                  events.push({ time: chat.createdat, label: intl.formatMessage({ id: "chat.report.timeline.started" }) })
                if (chat.iastartat && chat.iastartat !== '-')
                  events.push({ time: chat.iastartat, label: intl.formatMessage({ id: "chat.report.timeline.ia.started" }) })
                if (chat.iaendat && chat.iaendat !== '-')
                  events.push({ time: chat.iaendat, label: intl.formatMessage({ id: "chat.report.timeline.ia.ended" }) })
                if (chat.queueentryat && chat.queueentryat !== '-')
                  events.push({ time: chat.queueentryat, label: intl.formatMessage({ id: "chat.report.timeline.queue.entry" }) })
                if (chat.humanstartat && chat.humanstartat !== '-')
                  events.push({ time: chat.humanstartat, label: `${chat.assigneduser || intl.formatMessage({ id: "assigned" })} — ${intl.formatMessage({ id: "chat.report.timeline.human.started" })}` })
                if (chat.humanendat && chat.humanendat !== '-')
                  events.push({ time: chat.humanendat, label: intl.formatMessage({ id: "chat.report.timeline.ended" }) })

                if (events.length === 0) return null

                return (
                  <Accordion defaultExpanded style={{ marginBottom: '16px' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="subtitle2">
                        {intl.formatMessage({ id: "chat.report.timeline.title" })}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div style={{ paddingLeft: '8px', maxHeight: '200px', overflowY: 'auto' }}>
                        {events.map((event, index) => (
                          <div key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                            <div style={{
                              width: '10px', height: '10px', borderRadius: '50%',
                              backgroundColor: '#3f51b5', marginRight: '12px',
                              marginTop: '5px', flexShrink: 0
                            }} />
                            <div style={{ borderLeft: '2px solid #e0e0e0', paddingLeft: '12px', paddingBottom: '4px' }}>
                              <Typography variant="body2">
                                <strong>{event.time}</strong> — {event.label}
                              </Typography>
                            </div>
                          </div>
                        ))}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                )
              })()}
              {this.state.dialogHTMLString.length > 0 ? (() => {
                const chat = this.state.currentChat
                const humanStartMoment = chat?.humanstartat && chat.humanstartat !== '-'
                  ? moment(chat.humanstartat, 'DD/MM/YYYY HH:mm')
                  : null

                const iaMessages = humanStartMoment
                  ? this.state.dialogHTMLString.filter(m => moment(m.createdat).isBefore(humanStartMoment))
                  : this.state.dialogHTMLString

                const humanMessages = humanStartMoment
                  ? this.state.dialogHTMLString.filter(m => moment(m.createdat).isSameOrAfter(humanStartMoment))
                  : []

                return (
                  <>
                    {/* Bloco IA */}
                    {iaMessages.length > 0 && chat?.iastartat && chat.iastartat !== '-' && (
                      <Accordion defaultExpanded style={{ marginBottom: '12px' }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography variant="subtitle2" style={{ color: '#7b1fa2' }}>
                            🤖 {intl.formatMessage({ id: "chat.report.block.ia" })}
                            {chat?.iaduration && chat.iaduration !== '-' && (
                              <span style={{ marginLeft: '12px', fontWeight: 'normal', color: '#757575', fontSize: '0.85em' }}>
                                {intl.formatMessage({ id: "chat.report.ia.duration" })}: {chat.iaduration}
                              </span>
                            )}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div style={{ width: '100%', paddingRight: '8px', maxHeight: '35vh', overflowY: 'auto' }}>
                            {iaMessages.map(item => this.renderMessageItem(item))}
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    )}

                    {/* Bloco Humano */}
                    {humanMessages.length > 0 && (
                      <Accordion defaultExpanded style={{ marginBottom: '12px' }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography variant="subtitle2" style={{ color: '#1565c0' }}>
                            👤 {intl.formatMessage({ id: "chat.report.block.human" })}
                            {chat?.humanduration && chat.humanduration !== '-' && (
                              <span style={{ marginLeft: '12px', fontWeight: 'normal', color: '#757575', fontSize: '0.85em' }}>
                                {intl.formatMessage({ id: "chat.report.human.duration" })}: {chat.humanduration}
                              </span>
                            )}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div style={{ width: '100%', paddingRight: '8px', maxHeight: '45vh', overflowY: 'auto' }}>
                            {humanMessages.map(item => this.renderMessageItem(item))}
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    )}
                  </>
                )
              })() : (
                <h4>{intl.formatMessage({ id: "chat-report.no.messages.between.users" })}</h4>
              )}

            </DialogContent>

            <DialogActions style={{ padding: '16px 24px' }}>
              <Button onClick={this.closeHTMLRenderModal} variant='contained' color='secondary' style={{ width: '150px' }}>
                {<FormattedMessage id="close" />}
              </Button>
            </DialogActions>
          </Dialog>
          {this.state.metrics && (
            <Grid container spacing={2} style={{ marginBottom: '20px', marginTop: '15px' }}>
              {[
                { label: intl.formatMessage({ id: "chat.report.metric.total" }), value: this.state.metrics?.totalconversations },
                { label: intl.formatMessage({ id: "chat.report.metric.resolved.ia" }), value: this.state.metrics?.resolvedbyia },
                { label: intl.formatMessage({ id: "chat.report.metric.transferred" }), value: this.state.metrics?.transferredtohuman },
                { label: intl.formatMessage({ id: "chat.report.metric.tickets" }), value: this.state.metrics?.ticketsgenerated },
                { label: intl.formatMessage({ id: "chat.report.metric.avg.ia" }), value: formatDuration(null, null, this.state.metrics.avgiaseconds) },
                { label: intl.formatMessage({ id: "chat.report.metric.avg.human" }), value: this.state.metrics ? formatDuration(null, null, this.state.metrics.avghumanseconds) : '-' },
                { label: intl.formatMessage({ id: "chat.report.metric.avg.queue" }), value: this.state.metrics ? formatDuration(null, null, this.state.metrics.avgqueueseconds) : '-' },
                { label: intl.formatMessage({ id: "chat.report.metric.avg.sla" }), value: this.state.metrics ? formatDuration(null, null, this.state.metrics.avgslaseconds) : '-' },
              ].map((metric, index) => (
                <Grid item xs={6} sm={3} key={index}>
                  <Card style={{ textAlign: 'center', padding: '8px', height: '100%' }}>
                    <CardContent style={{ paddingBottom: '8px' }}>
                      <Typography variant="h5" color="primary">
                        <strong>{metric.value ?? '-'}</strong>
                      </Typography>
                      <Typography variant="caption" color="textSecondary" style={{ lineHeight: 1.2, display: 'block', marginTop: '4px' }}>
                        {metric.label}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
          <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
            <Accordion >
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                <Typography className={classes.heading}>{intl.formatMessage({ id: "filters" })}</Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Grid fullWidth container spacing={2} style={{ marginBottom: 20 }}>
                  <Grid item xs={12} md={4} >
                    <TextField
                      fullWidth
                      label={intl.formatMessage({ id: "Id" })}
                      inputProps={{ maxLength: 40 }}
                      autoComplete='off'
                      type="number"
                      variant='outlined'
                      name='id'
                      onChange={this.handleInputChange}
                      value={this.state.id}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} >
                    <TextField
                      fullWidth
                      label={intl.formatMessage({ id: "Solicitante" })}
                      inputProps={{ maxLength: 40 }}
                      autoComplete='off'
                      type="text"
                      variant='outlined'
                      name='requestuser'
                      onChange={this.handleInputChange}
                      value={this.state.requestuser}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} >
                    <TextField
                      fullWidth
                      label={intl.formatMessage({ id: "Responsável" })}
                      inputProps={{ maxLength: 40 }}
                      autoComplete='off'
                      type="text"
                      variant='outlined'
                      name='assigned'
                      onChange={this.handleInputChange}
                      value={this.state.assigned}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} >
                    <SimpleAutoComplete
                      name='channelId'
                      options={this.state.channelOptions}
                      label={intl.formatMessage({ id: "channel" })}
                      stateName='channelId'
                      changeSelect={(stateName, value) => this.handleChangeAutoComplete(stateName, value)}
                      selected={this.state.formData.channelId}
                      htmlOptions={true}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} >
                    <SimpleAutoComplete
                      name="MessageProviderId"
                      label={intl.formatMessage({ id: "select.message_provider" })}
                      options={this.state.optionsMessageProviders}
                      stateName='MessageProviderId'
                      changeSelect={(stateName, value) => {
                        this.handleChangeAutoComplete(stateName, value)
                      }}
                      selected={this.state.formData.MessageProviderId}
                      htmlOptions={true}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} >
                    <SimpleAutoComplete
                      name="statusId"
                      label={intl.formatMessage({ id: "status" })}
                      options={this.state.statusOptions}
                      stateName='statusId'
                      changeSelect={(stateName, value) => {
                        this.handleChangeAutoComplete(stateName, value)
                      }}
                      selected={this.state.formData.statusId}
                      htmlOptions={true}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} >
                    <SimpleAutoComplete
                      name="OrganizationFilter"
                      label={intl.formatMessage({ id: "organization" })}
                      options={this.state.organizationList}
                      stateName='OrganizationFilter'
                      changeSelect={(stateName, value) => this.setState({ [stateName]: value?.id || 0 })}
                      htmlOptions={true}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.hasTicket}
                          onChange={(e) => this.setState({ hasTicket: e.target.checked })}
                          color="primary"
                        />
                      }
                      label={intl.formatMessage({ id: "chat.report.filter.has.ticket" })}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.onlyIa}
                          onChange={(e) => this.setState({ onlyIa: e.target.checked, onlyHuman: e.target.checked ? false : this.state.onlyHuman })}
                          color="primary"
                        />
                      }
                      label={intl.formatMessage({ id: "chat.report.filter.only.ia" })}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.onlyHuman}
                          onChange={(e) => this.setState({ onlyHuman: e.target.checked, onlyIa: e.target.checked ? false : this.state.onlyIa })}
                          color="primary"
                        />
                      }
                      label={intl.formatMessage({ id: "chat.report.filter.only.human" })}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>

              <AccordionDetails>
                <Typography className={classes.heading}>{intl.formatMessage({ id: "date" })}</Typography>
                <Grid container style={{ marginBottom: 20 }}>
                  <Grid item xs={12} md={12} lg={4}>
                    <RadioGroup row value={this.state.radioSelectedOption} onChange={this.handleRadioChange}>
                      <FormControlLabel value="1" control={<Radio />} label={intl.formatMessage({ id: "today" })} />
                      <FormControlLabel value="2" control={<Radio />} label={intl.formatMessage({ id: "current.month" })} />
                      <FormControlLabel value="3" control={<Radio />} label={intl.formatMessage({ id: "period" })} />
                    </RadioGroup>
                  </Grid>
                  {this.state.radioSelectedOption == "3" &&
                    <>
                      <Grid item xs={12} md={6} lg={4}>
                        {this.renderDatePickerStart()}
                      </Grid>
                      <Grid item xs={12} md={6} lg={4}>
                        {this.renderDatePickerEnd()}
                      </Grid>
                    </>
                  }
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Grid container style={{ marginBottom: 10 }}>
              <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                <Button type='submit' fullWidth variant='contained' color='secondary' >
                  {<FormattedMessage id="filter" />}
                </Button>
              </Grid>
              {this.state.showGrid && <Grid item xs={6} sm={5} md={2} style={{ marginTop: 10, marginRight: 10 }}>
                <Button fullWidth variant='contained' color='primary' onClick={this.getExcel}>
                  {<FormattedMessage id="export.plan" />}
                </Button>
              </Grid>}
            </Grid>
          </form>

          {this.state.showGrid && <>
            <MyMaterialTable
              title=""
              columns={[
                { title: intl.formatMessage({ id: "id" }), field: 'id' },
                { title: intl.formatMessage({ id: "date" }), field: 'createdat' },
                {
                  title: intl.formatMessage({ id: "requestuser" }),
                  field: 'requestinguser',
                  render: (row) => {
                    return (row?.requestinguser && row?.requestinguser !== "")
                      ? <span>{row?.requestinguser}</span>
                      : <span>{row?.customername}</span>
                  }
                },
                { title: intl.formatMessage({ id: "requester.number" }), field: 'phone' },
                { title: intl.formatMessage({ id: "channel" }), field: 'channelname' },
                { title: intl.formatMessage({ id: "ProviderType" }), field: 'messageprovidername' },
                { title: intl.formatMessage({ id: "status" }), field: 'statusname', render: (row) => { return row.statusname ? <Chip label={row.statusname} color={getStatusChipColor(row.statusname)} size="small" /> : '-' } },
                {
                  title: intl.formatMessage({ id: "chat.report.closure.type" }), field: 'closuretypename',
                  render: (row) => {
                    if (!row.closuretypename) return '-'
                    const semResposta = row.closuretypename.toLowerCase().includes('sem resposta') || row.closuretypename.toLowerCase().includes('no response')
                    return semResposta
                      ? <Chip label={row.closuretypename} size="small" color="error" />
                      : <span>{row.closuretypename}</span>
                  }
                },
                { title: intl.formatMessage({ id: "chat.report.ia.start" }), field: 'iastartat' },
                { title: intl.formatMessage({ id: "chat.report.ia.end" }), field: 'iaendat' },
                { title: intl.formatMessage({ id: "chat.report.ia.duration" }), field: 'iaduration' },
                { title: intl.formatMessage({ id: "chat.report.queue.entry" }), field: 'queueentryat' },
                { title: intl.formatMessage({ id: "chat.report.wait.time" }), field: 'waittime', render: (row) => row.waittimeseconds > WAIT_TIME_ALERT_SECONDS ? <span style={{ color: '#e65100', fontWeight: 'bold' }}>⚠ {row.waittime}</span> : <span>{row.waittime}</span> },
                { title: intl.formatMessage({ id: "chat.report.human.start" }), field: 'humanstartat' },
                { title: intl.formatMessage({ id: "chat.report.human.end" }), field: 'humanendat' },
                { title: intl.formatMessage({ id: "chat.report.human.duration" }), field: 'humanduration', render: (row) => row.humandurationseconds > HUMAN_DURATION_ALERT_SECONDS ? <span style={{ color: '#e65100', fontWeight: 'bold' }}>⚠ {row.humanduration}</span> : <span>{row.humanduration}</span> },
                { title: intl.formatMessage({ id: "chat.report.transfer.count" }), field: 'transfercount', render: (row) => row.transfercount > TRANSFER_COUNT_ALERT ? <span style={{ color: '#e65100', fontWeight: 'bold' }}>⚠ {row.transfercount}</span> : <span>{row.transfercount || 0}</span> },
                { title: intl.formatMessage({ id: "assigned" }), field: 'assigneduser' },
                { title: intl.formatMessage({ id: "ticket" }), field: 'calledid', render: (row) => row.calledid ? <Chip label={`#${row.calledid}`} size="small" sx={{ backgroundColor: '#9c27b0', color: 'white' }} onClick={() => this.props.history.push(`/${this.props.match.params.lang}/called-accompaniment/${row.calledid}`)} /> : '-' },
                { title: intl.formatMessage({ id: "chat.report.organization" }), field: 'organizationname' },
                { title: intl.formatMessage({ id: "chat.report.conversation.end" }), field: 'conversationendat', render: (row) => row.conversationendat ? moment(row.conversationendat).format('DD/MM/YYYY HH:mm') : '-'},
                { title: intl.formatMessage({ id: "chat.report.message.count" }), field: 'messagecount', render: (row) => row.messagecount || 0 },
                { title: intl.formatMessage({ id: "chat.report.message.cost" }), field: 'messagecost', render: (row) => `R$ ${Number(row.messagecost || 0).toFixed(4)}` },
                { title: intl.formatMessage({ id: "chat.report.tags" }), field: 'tags', render: (row) => row.tags ? row.tags : '-'},
                { title: intl.formatMessage({ id: "conversation" }), field: 'Message' },
              ]}
              data={this.state.calledsList} />

            <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
              <Grid item xs={12} md={3}>
                <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
              </Grid>
              <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
              </Grid>
            </Grid>
          </>}
        </>
      );
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })} >
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />
            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card >
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      {<FormattedMessage id="requested.chats" />}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <Can I="List" a="ChatReport">
              {tableList()}
            </Can>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

ChatReport.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ChatReport)))
ChatReport.contextType = AbilityContext
